import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router swaps the page without touching the scroll position, so a link
 * clicked at the bottom of one page used to land at the bottom of the next,
 * and `/honest-numbers#treasury` never reached the treasury. This restores
 * what a full page load would do: jump to the `#hash` target when there is
 * one, otherwise to the top.
 */
export function ScrollOnNavigate() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // The target may render a frame later (the page mounts on this commit).
      const id = decodeURIComponent(hash.slice(1));
      const t = window.setTimeout(() => document.getElementById(id)?.scrollIntoView(), 0);
      return () => window.clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
}
